import * as Config from '../../../../config';
import React, { useCallback, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { io } from "socket.io-client";
import {
  newLocalStorePlaylists,
  pushStorePlaylists,
  incrementStorePlaylists,
  removeStorePlaylists,
  saveLocalPlaylist,
  setModal,
  addToast
} from "../../../../actions/index";
import {
  setStateShortcuts
} from "../../shortcut/redux/actions/index";
import {
  setEnablePM,
  setSocketPM,
  setRoomsPM,
  setInRoomPM,
  setSocketConnectPM,
  addMessagePM,
  setStateServerPM,
  setRequestPM,
  setPlayersInRoomPM,
  setChatPM,
  setPermissionStatePlayerPM,
  setWatcherPM,
  setAudioInfosPM,
  setStateLockPM,
  setQueuesDJ,
  setResponseToDJ
} from "../redux/actions/index";

import ModalCTA from '../../modal/ModalCTA';
import ModalButton from '../../modal/ModalButton';

let startTime = null;
let lostConnect = false;
let lock = false;
let globalOutsider = false;

// Communication Server <=> Client
const useSocketPM = (user, outsider) => {
  const api = useSelector( state => state.api )
  const enable = useSelector( state => state.enablePM )
  const devMode = useSelector( state => state.devPM )
  const dispatch = useDispatch();
  globalOutsider = outsider; // Since the socket is one time, need a global to access methods

  const destroy = useCallback(() => {
    dispatch(setEnablePM(false));
    dispatch(setStateServerPM(false));
    dispatch(setSocketPM(null));
    dispatch(setSocketConnectPM(false));
    const el = document.getElementById(`player`);
    lock = false; // Enable the recreation of a socket;
    if (el) { el.style['pointer-events'] = `initial` }
  }, [dispatch]);

  const warning = (e, label = 'The host has locked your DJ controls.') => {
    const block = document.getElementById(`viewer-player-lock`);
    const chatFocus = (document.getElementById(`input-chat`) && document.getElementById(`input-chat`) === document.activeElement);
    if (block) {
      block.textContent = label;
    }
    if (block && !chatFocus) {
      block.classList.remove("none");
      setTimeout(() => {  block.classList.add("none");  }, 2000);
    }
  }
  window['pm-warning'] = warning;

  //inital - Only one socket by client is instanciated - Connected or Not
  useEffect(() => {
    if ((enable && lock === false && (user || outsider)) || devMode) {
      const url = Config.PM_URL; // 'http://localhost:9000'; // DEV
      const path = Config.PM_PATH; // '/'; // DEV

      const socket = io(url, { autoConnect: false, path: `${path}socket.io` });
      lock = true;

      // STATE GLOBAL
      socket.on("server on", (state) => {
        dispatch(setStateServerPM(true));
      });

      window.getLatencyServer = () => {
        startTime = Date.now();
        socket.emit('ping');
      };
      socket.on('pong', function() {
        const latency = Date.now() - startTime;
        console.log(`Latency with server ${latency}ms `);
      });

      window.getStateServer = () => {
        socket.emit('getStateServer');
      }

      // ROOMS
      socket.on("rooms", (rooms) => {
        dispatch(setRoomsPM(rooms));
      });
      socket.on("update rooms", (rooms) => {
        dispatch(setRoomsPM(rooms));
      });
      socket.on("set players in host room", (players) => {
        dispatch(setPlayersInRoomPM(players));
      });
      socket.on("set client state", (isViewer) => {
        if (window['YouDJ'] && window['YouDJ'].partymode_onoff) {
          window['YouDJ'].partymode_onoff(true, false, isViewer);
        }
      });
      socket.on("set watcher", (state, isOn = true) => {
        dispatch(setWatcherPM(state));
        socket.emit(`update local spectator state`, state);

        let el = document.getElementById(`player`);
        if (el) { el.style['pointer-events'] = (state) ? `none` : `initial` }
        let fx1 = document.getElementById(`sfx1_area`);
        if (fx1) { fx1.style['pointer-events'] = (state) ? `none` : `initial` }
        let fx2 = document.getElementById(`sfx2_area`);
        if (fx2) { fx2.style['pointer-events'] = (state) ? `none` : `initial` }

        el = document.getElementById(`alpha2`);
        if (el) {
          if (state) {
            el.addEventListener('click', warning);
          } else {
            el.removeEventListener('click', warning);
          }
        }

        // VIEWERS - Disable Shortcuts
        setStateShortcuts(!state);

      });
      socket.on("join room", (room, isReconnect = false) => {
        dispatch(setInRoomPM(room));
        if (!outsider) { localStorage.setItem('a5RAW%93W!gph8', room.id); }
        dispatch(setPlayersInRoomPM(room.players));
        dispatch(setChatPM(true));

        if (window['YouDJ'] && window['YouDJ'].partymode_onoff) {
          const userID = (user) ? user.id : localStorage.getItem(`cQfdJ@gD8yjHqr`);

          const owner = (room.owner === userID);
          const u = room.players.find(x => x.id === userID);
          const viewer = (u) ? u.spectator : false;

          if (isReconnect && owner) {
            window['YouDJ'].partymode_onoff(true, false, viewer);
            setTimeout(() => {
              window['YouDJ'].partymode_onoff(true, owner, viewer);

              // Owner is back, all co-host master -> slave
              setTimeout(() => { socket.emit(`host back cohost slave`); }, 4000)

            }, 5000);
          } else {
            window['YouDJ'].partymode_onoff(true, owner, viewer);
          }

        }
      });
      socket.on("update host room", (room) => {
        dispatch(setInRoomPM(room));
      })
      socket.on("shared playlist", ({owner_name, tracks, name = 'Party Playlist', timeout}) => {
        setTimeout(async () => {
          const results = (tracks.length > 0 && api) ? await api.getFromApi(`/catalog/tracks/?per_page=100&id=${tracks.map(id => id).join(',')}`, false)
            .then( (response) => response.data.results.map(Config.formattedFromBP) )
            .catch(e => ([]))
            : [];
          const orderResults = tracks.map( x => results.find( y => y.id === x ) );
          dispatch(newLocalStorePlaylists(Config.UID_SHARED_PLAYLIST, name, orderResults.filter(x => (x)), { pm: true, is_shared: true, owner_name }))

        }, timeout);
      })
      socket.on("update shared playlist", async ({tracks}) => {
        const results = (tracks.length > 0 && api) ? await api.getFromApi(`/catalog/tracks/?id=${tracks.map(id => id).join(',')}`, false)
          .then( (response) => response.data.results.map(Config.formattedFromBP) )
          .catch(e => ([]))
          : [];
        dispatch(pushStorePlaylists(Config.UID_SHARED_PLAYLIST, `tracks`, results));
        dispatch(incrementStorePlaylists(Config.UID_SHARED_PLAYLIST, `track_count`, results.length));
      })
      socket.on("suggested playlist", ({owner_name, tracks, timeout}) => {
        setTimeout(async () => {
          const results = (tracks.length > 0 && api) ? await api.getFromApi(`/catalog/tracks/?per_page=100&id=${tracks.map(x => {
            return (typeof x === 'number') ? x : x.id;
          }).join(',')}`, false)
            .then( (response) => response.data.results.map(Config.formattedFromBP) )
            .catch(e => ([]))
            : [];
          const orderResults = tracks.map( x => {
            const id = (typeof x === 'number') ? x : x.id;
            let track = results.find( y => y.id === id );
            if (track) {
              track.requestby = (x.username) ? x.username : null;
            }
            return track;
          });
          dispatch(newLocalStorePlaylists(Config.UID_SUGGESTED_PLAYLIST, `Requests`, orderResults.filter(x => (x)), { pm: true, is_suggested: true, owner_name }))

        }, timeout);
      })
      socket.on("update suggested playlist", async ({tracks}) => {
        let results = (tracks.length > 0 && api) ? await api.getFromApi(`/catalog/tracks/?id=${tracks.map(x => {
          return (typeof x === 'number') ? x : x.id ;
        }).join(',')}`, false)
          .then( (response) => response.data.results.map(Config.formattedFromBP) )
          .catch(e => ([]))
          : [];

        results = tracks.map( x => {
          const id = (typeof x === 'number') ? x : x.id;
          let track = results.find( y => y.id === id );
          if (track) {
            track.requestby = (x.username) ? x.username : null;
          }
          return track;
        });

        dispatch(pushStorePlaylists(Config.UID_SUGGESTED_PLAYLIST, `tracks`, results));
        dispatch(incrementStorePlaylists(Config.UID_SUGGESTED_PLAYLIST, `track_count`, results.length));
      })

      socket.on("leave room", (room) => {
        const owner = (user) ? (room.owner === user.id) : false;
        if (window['YouDJ'] && window['YouDJ'].partymode_onoff) {
          window['YouDJ'].partymode_onoff(false, owner, false);
        }
        localStorage.removeItem('a5RAW%93W!gph8');
        dispatch(setInRoomPM(null));
        socket.emit("analytics", { roomID: room.id });
        setTimeout(() => {
          // AUTO SAVE Session PLAYLIST FOR EVERYONE
          if (room.autosave && room.sharedPlaylistLength > 0 && !owner) {
            const yesClick = () => {
              dispatch(saveLocalPlaylist(Config.UID_SHARED_PLAYLIST, `${room.name}`))
              dispatch(removeStorePlaylists(Config.UID_SHARED_PLAYLIST));
              dispatch(removeStorePlaylists(Config.UID_SUGGESTED_PLAYLIST));
            }
            if (!globalOutsider) {
              dispatch(setModal({
                content: (
                  <ModalCTA
                    title={`The host is ending the party.`}
                    classTitle={`shrink`}
                    description={`Do you want to save the party playlist?`}
                    styleDescription={{marginBottom: 10}}
                    styleContainer={{marginTop: `-30%`, marginLeft: `-10%`}}
                    classModal={`bottom-reduce`}
                    styleBody={{gap: 26}}
                  >
                    <ModalButton label={`Save playlist`} className={`primary`} onClick={yesClick} />
                    <ModalButton label={`Close session`} className={`cancel`} />
                  </ModalCTA>
                ),
                underlayClickExits: false
              }));
            } else {
              dispatch(setModal({
                content: (
                  <ModalCTA
                    title={`The host is ending the party.`}
                    classTitle={`shrink`}
                    styleContainer={{marginTop: `-50%`, marginLeft: `-5%`}}
                  >
                    <ModalButton label={`Close`} className={`primary`} />
                  </ModalCTA>
                ),
                underlayClickExits: false
              }));
            }
          } else {
            if (!outsider) {
              dispatch(removeStorePlaylists(Config.UID_SHARED_PLAYLIST));
              dispatch(removeStorePlaylists(Config.UID_SUGGESTED_PLAYLIST));
            }
          }
        }, 250)
      });
      socket.on("kicked", (roomID) => {
        socket.emit("force kick", { roomID });
        dispatch(setModal({
          content: (
            <ModalCTA
              title={`Host has removed you from the session.`}
              styleContainer={{marginTop: `-70%`, marginLeft: `-10%`}}
              styleBody={{ gap: 36 }}
            >
              <ModalButton label={`Close`} />
            </ModalCTA>
          )
        }));
      });
      socket.on("room fulled", (roomID) => {
        const dump = localStorage.getItem('a5RAW%93W!gph8');
        localStorage.removeItem('a5RAW%93W!gph8');
        dispatch(setInRoomPM(null));
        dispatch(setEnablePM(false));

        const refresh = () => {
          localStorage.setItem('a5RAW%93W!gph8', dump);
          dispatch(setEnablePM(true));
        }
        dispatch(setModal({
          content: (
            <ModalCTA
              title={`Sorry, this session is currently at capacity.`}
              styleContainer={{marginTop: `-60%`, marginLeft: `-5%`}}
              classModal={`bottom-reduce`}
              styleBody={{ gap: 36 }}
            >
              <ModalButton label={`Try again`} onClick={refresh} />
              <ModalButton label={`No thanks`} className={`cancel`} />
            </ModalCTA>
          )
        }));
      });

      socket.on("full actives", () => {
        dispatch(setModal({
          content: (
            <ModalCTA
              title={`Sorry, The DJ booth is currently at capacity.`}
              styleContainer={{marginTop: `-60%`, marginLeft: `-20%`}}
              styleBody={{ gap: 36 }}
            >
              <ModalButton label={`Close`} />
            </ModalCTA>
          )
        }));
      });

      socket.on("no permission", () => {
        localStorage.removeItem('a5RAW%93W!gph8');
        dispatch(setInRoomPM(null));
        dispatch(setEnablePM(false));
        dispatch(setModal({
          content: (
            <ModalCTA
              title={`You don't have the right permission to access the session.`}
              styleContainer={{marginTop: `-60%`, marginLeft: `-20%`}}
              styleBody={{ gap: 36 }}
            >
              <ModalButton label={`Close`} />
            </ModalCTA>
          )
        }));
      });

      socket.on("get stateplayer", (owner) => {
        if (owner === user.id) {
          dispatch(setPermissionStatePlayerPM(true));
        }
      });

      socket.on("room destroyed", () => {
        localStorage.removeItem('a5RAW%93W!gph8');
        dispatch(setEnablePM(false));
        setTimeout(() => {
          dispatch(setModal({
            content: (
              <ModalCTA
                title={`This party has ended.`}
                description={`Sorry this session no longer exists.`}
                styleContainer={{marginTop: `-80%`, marginLeft: `-10%`}}
                styleBody={{ gap: 16 }}
                styleDescription={{ marginBottom: 20 }}
              >
                <ModalButton label={`Close`} />
              </ModalCTA>
            )
          }));
        }, 1000);
      });

      socket.on("session already opened", () => {
        dispatch(setInRoomPM(null));
        dispatch(setEnablePM(false));
        dispatch(setStateLockPM(true));
        setTimeout(() => {
          dispatch(setModal({
            content: (
              <ModalCTA
                title={`Your account is already connected to another party.`}
                classTitle={`small`}
                styleContainer={{marginTop: `-70%`, marginLeft: `-10%`}}
              >
                <ModalButton label={`Close`} />
              </ModalCTA>
            )
          }));
        }, 1000);
      });

      socket.on("switch owner", () => {
        if (window['YouDJ'] && window['YouDJ'].partymode_onoff) {
          window['YouDJ'].partymode_onoff(true, true, false);
        }
        dispatch(addToast({ content: <span>You are the new host</span>, iconStyle: { padding: '24px 16px', marginRight: 16 } }));
      });

      socket.on("new message", (message) => {
        dispatch(addMessagePM(message));
      });

      socket.on("load audio", ({ deckID, trackID, url }) => {
        dispatch(setRequestPM({ deck : deckID, track: trackID, url }));
      })

      socket.on("update audio infos", (audio) => {
        dispatch(setAudioInfosPM(audio));
      })

      socket.on("end warning", ({ label }) => {
        dispatch(setModal({
          content: (
            <ModalCTA
              title={`Your session  is about to end.`}
              classTitle={`shrink`}
              description={`${label} remaining on this session.`}
              styleDescription={{ marginBottom: 10 }}
              styleContainer={{marginTop: `-60%`, marginLeft: `-5%`}}
              classModal={`bottom-reduce`}
              styleBody={{gap: 26}}
            >
              <ModalButton label={`Continue`} />
              <ModalButton label={`Start new session`} className={`cancel`} />
            </ModalCTA>
          )
        }));
      });

      socket.on("end session", ({ roomName }) => {
        const yesClick = () => {
          dispatch(saveLocalPlaylist(Config.UID_SHARED_PLAYLIST, `${roomName}`))
        }
        dispatch(setModal({
          content: (
            <ModalCTA
              title={`Your Session has ended.`}
              classTitle={`small`}
              styleContainer={{marginTop: `-70%`, marginLeft: `-5%`}}
              classModal={`bottom-reduce`}
              styleBody={{gap: 26}}
            >
              <ModalButton label={`Save your playlist`} className={`primary`} onClick={yesClick} />
              <ModalButton label={`No thanks`} className={`cancel`} />
            </ModalCTA>
          ),
          underlayClickExits: false
        }));
      });

      socket.on("new message from player", (message) => {
        if (window['YouDJ'] && window['YouDJ'].partymode_got_message) {
          window['YouDJ'].partymode_got_message(message);
        }
      });

      socket.on("set queues dj", (list) => {
        dispatch(setQueuesDJ(list));
      });

      socket.on("response to dj", (response) => {
        dispatch(setResponseToDJ(response));
      });

      /* AIRCORE */

      socket.on('apply player by aircore', (state) => {
        if (!state.enable && window.a0_0x1bd9af) {
          window.a0_0x1bd9af(1, 3, state.d1 ? state.d1 : 0);
          window.a0_0x1bd9af(2, 3, state.d2 ? state.d2 : 0);
        }
      });

      /* GLOBAL */

      socket.on("connect", () => {
        lostConnect = false;
        dispatch(setSocketConnectPM(true));
      });
      socket.on("reconnect", () => {
        lostConnect = false;
      });
      socket.on("disconnect", (err) => {
        if (err !== 'transport close') {
          lostConnect = true;
          dispatch(setSocketConnectPM(false));
          dispatch(setModal({
            content: (
              <ModalCTA
                title={`It seems you lost your connection.`}
                styleContainer={{marginTop: `-70%`, marginLeft: `-20%`}}
              >
                <ModalButton label={`Close`} />
              </ModalCTA>
            )
          }));
        }
      });

      socket.on("connect_error", (err) => {
        if (!lostConnect) {
          socket.close();
          localStorage.removeItem('a5RAW%93W!gph8');
          destroy();
          dispatch(setModal({
            content: (
              <ModalCTA
                title={`B2B Mode is currently under construction.`}
                classTitle={`small shrink`}
                styleContainer={{marginTop: `-70%`, marginLeft: `-10%`}}
              >
                <ModalButton label={`Close`} />
              </ModalCTA>
            )
          }));
        }
      })

      socket.on("connect_error", (err) => {
        if (err.message === "invalid username") {
          console.log(`PM Error - Need a username`)
        }
        if (err.message === "xhr poll error") {
          dispatch(setStateServerPM(false));
        }
      });
      socket.on('connect_failed', err => {
        dispatch(setStateServerPM(false));
      });


      const updateCursorLabel = (cursor, left, top, scaleX = 1, scaleY = 1) => {
        cursor.style.opacity = 1;
        cursor.style.transform = `translate(${left}px, ${top}px) scaleX(${scaleX}) scaleY(${scaleY})`;
        if (scaleX === -1) {
          cursor.classList.add(`iScaleX`);
        } else {
          cursor.classList.remove(`iScaleX`);
        }
        if (scaleY === -1) {
          cursor.classList.add(`iScaleY`);
        } else {
          cursor.classList.remove(`iScaleY`);
        }
      }

      socket.on("mouse move", (mouse) => {
        const player = document.getElementById(`player`);
        let cursor = document.getElementById(`CL|${mouse.u}`);
        if (cursor) {
          if (mouse.c.disable) {
            cursor.style.opacity = 0;
          } else {
            cursor.style.opacity = 1;
            const pCoord = player.getBoundingClientRect();
            const pCursor = cursor.getBoundingClientRect();
            const scaleOwnPlayer = pCoord.width / 1420;
            const scaleX = (mouse.c.s === scaleOwnPlayer) ? 1 : ((mouse.c.s <= scaleOwnPlayer) ? 1 + scaleOwnPlayer - mouse.c.s : scaleOwnPlayer ); //0.93
            const calcLeft = ((((mouse.c.x * pCoord.width) / mouse.c.w / scaleX))) - 0;
            const calcTop = ((((mouse.c.y * pCoord.height) / mouse.c.h))) - 0;
            const tScaleX = calcLeft > (pCoord.width / 2) ? -1 : 1;
            const tScaleY = calcTop > (pCoord.height / 1.5) ? -1 : 1;
            const left = `${calcLeft - (tScaleX === -1 ? pCursor.width : 0)}`; // cursor.style.left
            const top = `${calcTop - (tScaleY === -1 ? pCursor.height : 0)}`; // cursor.style.top
            updateCursorLabel(cursor, left, top, tScaleX, tScaleY);
          }
        }
      });
      socket.on("cursor from action", ({ key, uid }) => { // From MIDI | Shortcuts
        const divAction = document.getElementById(key);
        const player = document.getElementById(`player`);
        let cursor = document.getElementById(`CL|${uid}`);
        if (cursor && divAction) {
          const pCoord = player.getBoundingClientRect();
          const pCursor = cursor.getBoundingClientRect();
          const pDivAction = divAction.getBoundingClientRect();
          let left = (pDivAction.x + (pDivAction.width / 2) - (window.sidebar_mode_enable ? Config.SIDE_WIDTH : 0));
          let top = (pDivAction.y + (pDivAction.height / 2) - Config.TAB_BAR_HEIGHT - (window.banner_enable ? Config.TAB_BAR_HEIGHT : 0));
          const tScaleX = left > (pCoord.width / 2) ? -1 : 1;
          const tScaleY = top > (pCoord.height / 1.5) ? -1 : 1;
          left -= (tScaleX === -1) ? pCursor.width : 0;
          top -= (tScaleY === -1) ? pCursor.height : 0;
          updateCursorLabel(cursor, left, top, tScaleX, tScaleY);
        }
      });

      socket.on("join dev room", ({room, master}) => {
        dispatch(setInRoomPM(room));
        if (window['YouDJ'] && window['YouDJ'].partymode_onoff) {
          window['YouDJ'].partymode_onoff(true, master, !master);
          alert(`You're the ${master ? `master` : `viewer` }`)
        }
      });

      dispatch(setSocketPM(socket));
    } else if (!enable && user && localStorage.getItem('a5RAW%93W!gph8')) {
      dispatch(setEnablePM(true));
    } else if (!enable) {
      destroy();
    }
  }, [enable, user, outsider, devMode, destroy, dispatch, api])

};

export default useSocketPM;
